import { isNil } from 'ramda'
import { createReducer } from 'utils/redux'

const defaultState = {
  chatOpen: false,
  closeChatRedirectUrl: null,
  conversationHistoryOpen: false,
  initComplete: false,
  isChatTakeover: false,
  matchedHours: false,
  matchedTargeting: false
}

const chatOpenHandler = ({ draft }) => {
  draft.chatOpen = true
}

const chatClosedHandler = ({ draft }) => {
  draft.chatOpen = false
}

const toggleChatTakeoverHandler = ({ action, draft }) => {
  if (action.payload) {
    draft.conversationHistoryOpen = false
  }
}

const toggleConversationHistoryHandler = ({ action, draft }) => {
  draft.conversationHistoryOpen = action.payload.conversationHistoryOpen
}

const toggleInitCompleteHandler = ({ action, draft }) => {
  draft.initComplete = action.payload.initComplete
}

const toggleWidgetTargetingCompleteHandler = ({ action, draft }) => {
  const { matchedHours, matchedTargeting} = action.payload

  if (!isNil(matchedHours)) {
    draft.matchedHours = matchedHours
  }

  if (!isNil(matchedTargeting)) {
    draft.matchedTargeting = matchedTargeting
  }
}

const setCloseChatRedirectUrl = ({ action, draft }) => {
  draft.closeChatRedirectUrl = action.payload
}

const actions = {
  INIT_COMPLETE: toggleInitCompleteHandler,
  SET_CLOSE_CHAT_REDIRECT_URL: setCloseChatRedirectUrl,
  OPEN_CHAT: chatOpenHandler,
  CLOSE_CHAT: chatClosedHandler,
  TOGGLE_CHAT_TAKEOVER: toggleChatTakeoverHandler,
  TOGGLE_CONVERSATION_HISTORY: toggleConversationHistoryHandler,
  TOGGLE_WIDGET_TARGETING_MATCHED: toggleWidgetTargetingCompleteHandler
}

const viewReducer = createReducer(
  defaultState,
  actions
)

export default viewReducer
